export const INTENT_QUERY_KEY = 'intent' as const;

const ALLOWED_RETURN_PATHS = ['/app', '/account', '/upgrade', '/billing/return'] as const;

export type AllowedReturnPath = (typeof ALLOWED_RETURN_PATHS)[number];

export function getSafeReturnPath(raw: string | null | undefined): AllowedReturnPath {
  if (!raw || !raw.startsWith('/')) return '/app';
  const pathname = raw.split('?')[0] ?? '';
  if ((ALLOWED_RETURN_PATHS as readonly string[]).includes(pathname)) {
    return pathname as AllowedReturnPath;
  }
  return '/app';
}

/** Merge `intent` from the current flow onto a destination path (path may already include a query). */
export function appendIntentToPath(path: string, searchParams: URLSearchParams): string {
  const intent = searchParams.get(INTENT_QUERY_KEY);
  if (!intent) return path;
  const [pathname, rawQuery] = path.split('?');
  const q = new URLSearchParams(rawQuery ?? '');
  q.set(INTENT_QUERY_KEY, intent);
  return `${pathname}?${q.toString()}`;
}

export function postAuthDestination(searchParams: URLSearchParams): string {
  const path = getSafeReturnPath(searchParams.get('return'));
  return appendIntentToPath(path, searchParams);
}

/** Build `/login` or `/signup` search string preserving `intent` and optional `return`. */
export function buildAuthRedirectSearch(params: URLSearchParams): string {
  const next = new URLSearchParams();
  const intent = params.get(INTENT_QUERY_KEY);
  if (intent) next.set(INTENT_QUERY_KEY, intent);
  const ret = params.get('return');
  if (ret) next.set('return', getSafeReturnPath(ret));
  const s = next.toString();
  return s ? `?${s}` : '';
}
